export const CATEGORIES = [
    { value: 'recommendations', label: 'Recommended' },
    { value: 'favorites', label: 'Favorites' },
];
